import axios from 'axios'

export default {
  namespaced: true,
  state: {
    configSettings: {},
  },
  mutations: {
    setConfigSettings(state, payload) {
      state.configSettings = payload
    },
  },
  getters: {
    configSettings: (state) => {
      return state.configSettings
    },
  },
  actions: {
    onCommonConfigSettings({ commit, rootState }, { name }) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/config/' + name,
          method: 'GET',
        })
          .then((resp) => {
            commit('setConfigSettings', resp.data)
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
    onCommonConfigSettingsUpdate({ commit, rootState }, { name, data, notCommitToMain }) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/config/' + name,
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            commit('setConfigSettings', resp.data)
            if (!notCommitToMain) {
              let temp = Object.assign(rootState.companiesConfig, resp.data)
              commit('setCompaniesConfig', temp, { root: true })
            }
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
  },
}
